import { Component, Vue } from 'vue-property-decorator'
import { queryWorkOrderList, setWorkOrderStatus } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({
  name: 'ApproveListPage', components: { HighFilter }
})
export default class ApproveListPage extends Vue {
  private totalPage = 1;
  private totalNum = 1;
  private currentPage = 1;
  private filterTypeChoose = null;

  private tableData = []

  private showHighFilter = false
  private filterData: any = {}
  private filterResult: any = null
  private tableloading: any = true
  private groupChooseList: any = []
  private rejectSureDialogVisible: any = false
  private rejectDialogVisible: any = false
  private rejectReason: any = null
  private time: any = null
  created () {
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    let filterResult: any = null
    const data: any = sessionStorage.getItem('filterResult')
    filterResult = JSON.parse(data)
    const param: any = { page: this.currentPage }
    if (this.filterResult) {
      param.search = this.filterResult
    } else if (filterResult) {
      param.search = filterResult
    }
    if (this.filterTypeChoose) {
      param.type = this.filterTypeChoose
    }
    const result: any = await queryWorkOrderList(param)
    this.filterData = result.search
    const { allPage, currentPage, allNumber, workOrderList } = result
    this.tableData = workOrderList
    this.totalPage = allPage
    this.totalNum = allNumber
    this.currentPage = currentPage
    this.tableloading = false
  }

  /**
   * [description] 审批按钮被点击
   */
  private onApproveClick (item: any) {
    if (item.type === 1 || item.type === 2 || item.type === 3 || item.type === 4 || item.type === 7) {
      if (item.status) { // 已通过只有查看权限
        this.$router.push({ path: '/approve/sign', query: { id: item.id, type: item.type, action: 'look' } })
      } else {
        this.$router.push({ path: '/approve/sign', query: { id: item.id, type: item.type, action: 'look' } })
      }
    } else if (item.type === 6) {
      this.$router.push({ path: '/approve/classover', query: { id: item.id, classId: item.endClassId } })
    } else if (item.type === 5) { // 5是异常
      this.$router.push({ path: '/approve/anomaly', query: { id: item.id } })
    }
  }

  /**
   * [description] 审批类型筛选控件回调函数
   */
  private onFilterTypeChange () {
    this.currentPage = 1
    this.initPageData()
  }

  /**
   * [description] 分页切换回调函数
   */
  private async onPageChange () {
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    const filterResult = JSON.stringify(data) // 转化为JSON字符串
    sessionStorage.setItem('filterResult', filterResult)
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  private getRowKeys (row: any) {
    return row.id
  }

  private groupChoose (data: any) {
    this.groupChooseList = data.map((item: any) => { return item.id })
  }

  private async overClass () {
    this.rejectSureDialogVisible = true
  }

  private async onSuccessClick () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      this.tableloading = true
      const { error }: any = await setWorkOrderStatus({ idList: this.groupChooseList, status: 1 })
      if (!error) {
        this.$message({ message: '操作成功', type: 'success' })
        this.rejectSureDialogVisible = false
        this.groupChooseList = [];
        (this.$refs.multipleTable as HTMLFormElement).clearSelection()
        this.initPageData()
      }
      this.tableloading = false
    }, 400)
  }

  private async onDoClick () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      this.tableloading = true
      const { error }: any = await setWorkOrderStatus({ idList: this.groupChooseList, status: 2, comment: this.rejectReason })
      if (!error) {
        this.$message({ message: '操作成功', type: 'success' })
        this.rejectDialogVisible = false
        this.rejectSureDialogVisible = false
        this.groupChooseList = []
        this.rejectReason = null;
        (this.$refs.multipleTable as HTMLFormElement).clearSelection()
        this.initPageData()
      }
      this.tableloading = false
    }, 400)
  }

  private checkboxSelect (row: any) {
    if (row.status !== 0 || (row.status === 1 || row.status === 2)) {
      return false // 禁用
    } else {
      return true // 不禁用
    }
  }
}
